module.exports = __webpack_public_path__ + "img/brand-stepik.10c4c164.svg";